/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ListaInstytucji } from '../../models/lista-instytucji';

export interface ApiWebInstytucjeGet$Xml$Params {
  'X-User-NIPy'?: string;
}

export function apiWebInstytucjeGet$Xml(http: HttpClient, rootUrl: string, params?: ApiWebInstytucjeGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ListaInstytucji>> {
  const rb = new RequestBuilder(rootUrl, apiWebInstytucjeGet$Xml.PATH, 'get');
  if (params) {
    rb.header('X-User-NIPy', params['X-User-NIPy'], {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ListaInstytucji>;
    })
  );
}

apiWebInstytucjeGet$Xml.PATH = '/api/web/instytucje';
